import { useState } from 'react'

import { InputType } from 'src/types'
import { useLocales } from 'src/contexts'

import { MaintenanceFilters } from 'src/pages/ServiceMaintenanceHistory/types'
import { DEFAULT_MAINTENANCE_FILTERS } from 'src/pages/ServiceMaintenanceHistory/constants'
import { getSelectFields } from 'src/pages/ServiceMaintenance/helpers'
import { ServiceType } from 'src/pages/ServiceMaintenance/enums'
import { SheetForMaintenanceProps } from 'src/features/SheetForMaintenanceHistory/types'
import { getFilterFields } from 'src/features/SheetForMaintenanceHistory/helpers'

export const useSheetForMaintenanceHistory = ({
  filters,
  setFilters,
}: SheetForMaintenanceProps) => {
  const { translations } = useLocales()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [localFilters, setLocalFilters] = useState<MaintenanceFilters>(filters)

  const onSave = (): void => {
    setIsOpen(false)
    setFilters(localFilters)
  }

  const onReset = (): void => {
    setFilters(DEFAULT_MAINTENANCE_FILTERS)
    setIsOpen(false)
  }

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: keyof typeof localFilters,
    type: InputType,
  ): void => {
    setLocalFilters(prev => ({
      ...prev,
      [key]:
        type === 'number'
          ? event.target.value === ''
            ? null
            : Number(event.target.value)
          : event.target.value,
    }))
  }

  const handleChangeServiceType = (value: ServiceType): void => {
    setLocalFilters(prevState => ({ ...prevState, serviceType: value }))
  }

  return {
    locale: translations.maintenance.historyMaintenance.filters,
    filterFields: getFilterFields(
      translations.maintenance.historyMaintenance.filters,
    ),
    serviceTypeOptions: getSelectFields(translations.maintenance),
    isOpen,
    setIsOpen,
    onSave,
    onReset,
    handleChange,
    localFilters,
    handleChangeServiceType,
  }
}
